import React from 'react';

import {
  InfoCard,
  SparkDataSearchBar,
  SparkImageLoader,
} from 'sharedComponents/UI';
import { Box, Grid, Typography } from '@mui/material';
import { useBoardNodeTypes } from 'hooks/EntityTypes/useBoardNodeTypes';
import { useAddBoardNode } from 'hooks/Board';

type Props = {
  boardID: string | null | undefined;
  onClose: () => void;
};

function StartFromScratchView({ boardID, onClose }: Props) {
  const [query, setQuery] = React.useState('');
  const { boardNodeTypes } = useBoardNodeTypes();
  const { mutateAsync: addBoardNode, isLoading: isAddingBoardNode } =
    useAddBoardNode(boardID);
  const filteredBoardNodeTypes = React.useMemo(() => {
    return boardNodeTypes?.filter((boardNodeType) =>
      boardNodeType.attributes.name.toLowerCase().includes(query.toLowerCase())
    );
  }, [boardNodeTypes, query]);

  const handleAddNode = async (boardNodeTypeID: string) => {
    if (isAddingBoardNode) return;
    await addBoardNode({
      boardNodeTypeID: Number(boardNodeTypeID),
    });
    onClose();
  };

  const contentAvailable = React.useMemo(() => {
    return !!filteredBoardNodeTypes?.length;
  }, [filteredBoardNodeTypes?.length]);
  return (
    <Box>
      <SparkDataSearchBar
        setQuery={setQuery}
        placeholder='Search Output Type'
        sx={{ width: '100%' }}
      />
      {!contentAvailable && (
        <InfoCard info={`No output type found for ${query}`} type='error' />
      )}
      {contentAvailable && (
        <Grid container>
          {filteredBoardNodeTypes?.map((boardNodeType) => (
            <Grid
              xs={6}
              item
              container
              key={boardNodeType.id}
              padding={1}
              onClick={() => handleAddNode(boardNodeType.id)}
            >
              <Box
                width='100%'
                borderRadius='10px'
                border={(theme) => `1px solid ${theme.palette.borderColor}`}
                padding={1}
                display='flex'
                alignItems='center'
                gap={2}
                sx={{
                  cursor: isAddingBoardNode ? 'not-allowed' : 'pointer',
                  opacity: isAddingBoardNode ? 0.5 : 1,
                  '&:hover': {
                    borderColor: (theme) =>
                      isAddingBoardNode
                        ? theme.palette.borderColor
                        : theme.palette.primary.main,
                  },
                }}
              >
                <Box>
                  <SparkImageLoader
                    src={boardNodeType.attributes.iconURL}
                    width='30px'
                    height='30px'
                  />
                </Box>
                <Box>
                  <Typography>{boardNodeType.attributes.name}</Typography>
                  <Typography variant='caption' color='text.secondary'>
                    {boardNodeType.attributes.description}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}

export default StartFromScratchView;
